(function ($) {
  Drupal.behaviors.renutriv_section = {
    attach: function (context, settings) {
      $('body').addClass('brand-renutriv brand-renutriv-v2');
    }
  };
})(jQuery);
